(function () {
    'use strict';

    angular
        .module('ib-seat-map-module')
        .directive('ibCalculateHeightLeyendSeat', ibCalculateHeightLeyendSeat);

    function ibCalculateHeightLeyendSeat () {
        return {
            restrict: 'A',
            link: link
        };
        function link (scope, element) {
            angular.element('.ib-map-seats__leyend-button').on('click', () => {
                let calc = 0;
                const $parent = angular.element('.modal-body');
                const full = $parent[0].clientHeight;
                const header = angular.element('.ib-map-seats__header')[0].clientHeight;
                let footer = angular.element('.ib-modal-with-footer__footer--normal-price');
                footer.length < 1 ?
                    footer = angular.element('.ib-modal-with-footer__footer--long-price')[0].clientHeight :
                    footer[0].clientHeight;
                calc = full;
                angular.element(element).css('max-height', calc + 'px');
            });
        }
    }
})();
